import Script from 'next/script'

import { useI18n } from '@/shared/lib/i18n'

export function BrowserSupportScript() {
    const { lang } = useI18n()

    return (
        <Script id="browser-support" strategy="beforeInteractive">
            {`
                    var isUpdateBrowserPage = window.location.href.indexOf("update-browser") > -1

                    // NOTE The documentMode property is deprecated.It only works in Internet Explorer.
                    // All other browsers return undefined.
                    if (!isUpdateBrowserPage && window.document.documentMode) {
                        window.location.assign('/${lang}/update-browser')
                    }
                `}
        </Script>
    )
}
